export const COURIERS_COD = {
  couriers: [
    "FLE",
    "FLEWP",
    "FLEB",
    "JNT",
    "THP",
    "CJLX",
    "SCG",
    "NJV",
    "BEST",
    "TRUE",
    "EMST",
    "EMSX",
    "EMSW",
    "BEE",
    "EMSXP",
    "KRYQ",
    "ORNG",
    "KRYS",
    "DHL",
    "SPXP",
  ],
  condition: {
    default: {
      min: 100,
      max: 50000,
    },
    JNT: {
      min: 100,
      max: 10000,
    },
    MSE: {
      min: 100,
      max: 100000,
    },
    MSEC: {
      min: 100,
      max: 100000,
    },
    MSEF: {
      min: 100,
      max: 100000,
    },
    SPE: {
      min: 100,
      max: 100000,
    },
    SPEC: {
      min: 100,
      max: 100000,
    },
    SPXP: {
      min: 100,
      max: 36000,
    },
  },
};
